<template>
  <div class="container mx-auto">
    <div>
      <div v-if="isVisible">
        <div class="pb-6">
          <doe-page-heading :label="`Thanks ${firstName}`" class="mb-4" v-if="firstName" />
          <doe-paragraph
            v-if="isNewUser"
            class="mb-4"
            description="Your Department of Education (DoE) account has been created. You will receive an email at the personal email address you supplied, with your DoE account login details."
          />
          <doe-paragraph
            v-else
            class="mb-4"
            description="Your account has been updated as there is already an account linked to this email address."
          />
          <doe-banner
            class="mb-6"
            :label="`The email has been sent to: ${email}`"
            :description="[
              'You will be prompted to create your password on first login.'
            ]"
            v-if="email && isNewUser"
          />

          <doe-field-heading
            label="Here’s what you’ll need to do after logging in:"
            class="mb-4"
          />
          <ol v-if="isNewUser">
            <doe-stepper-block :step="1" :completed="true">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Enter your name and contact details
              </h5>
            </doe-stepper-block>
            <doe-stepper-block :step="2" :completed="true">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Confirm your identity
              </h5>
            </doe-stepper-block>
            <doe-stepper-block :step="3" :completed="false">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Register your service/s
              </h5>
            </doe-stepper-block>
            <doe-stepper-block :step="4" :completed="false" :finalStep="true">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Add your educators
              </h5>
            </doe-stepper-block>
          </ol>
          <ol v-else>
            <doe-stepper-block :step="1" :completed="false">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Register your service/s
              </h5>
            </doe-stepper-block>
            <doe-stepper-block :step="2" :completed="false" :finalStep="true">
              <h5 class="font-bold font-sans text-blue-900 mb-1">
                Add/Review your educators
              </h5>
            </doe-stepper-block>
          </ol>
          <doe-paragraph
            v-if="isNewUser"
            class="my-2"
            description="If you haven't received an email in 20-30 minutes, please first check your junk or spam folder and then contact the department's [Information and enquiries team](https://education.nsw.gov.au/early-childhood-education/about-us/contact-us)."
          />
        </div>
        <form-generator v-if="!isNewUser" :schema="schema" @form:next="formNext()" />
      </div>
      <div v-else>
        <doe-page-heading label="Creating account..." />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { serviceCallWithAuth } from "@/helpers/cognito";
import schema from "@/schemas/register/registerComplete";
import FormGenerator from "@/components/form/FormGenerator";
import DoePageHeading from "@/components/typography/PageHeading";
import DoeFieldHeading from "@/components/typography/FieldHeading";
import DoeParagraph from "@/components/typography/Paragraph";
import DoeStepperBlock from "@/components/typography/StepperBlock";
import DoeBanner from "@/components/banner/Banner";
import { REGISTRATION_STORAGE_KEY } from "@/store/registration";

export default {
  name: "AuthConfirmation",
  inject: {
    $validator: "$validator"
  },
  components: {
    FormGenerator,
    DoePageHeading,
    DoeFieldHeading,
    DoeParagraph,
    DoeStepperBlock,
    DoeBanner
  },
  data() {
    return {
      schema: schema,
      isNewUser: true,
      isVisible: false
    };
  },
  mounted() {
    let body = {
      user: this.getRegistrationUser,
      identities: this.getIdentities
    };
    console.log("in mounted register")
    this.$root.isLoading = true;
    let options = {
      path: "/greenid",
      method: "POST",
      body: JSON.stringify(body)
    };
    serviceCallWithAuth("doe-ttss", options)
      .then((resp) => {
        console.log("------------------"+resp.statusCode)
        if(resp.statusCode === '200'){
          console.log("setting user  this.isNewUser"+ this.isNewUser)
          this.isNewUser = false;
        }
        this.isVisible = true;
        sessionStorage.removeItem(REGISTRATION_STORAGE_KEY);
      })
      .catch(reason => {
        this.$root.translateModal(reason.message, "Identity verification failed");
        this.$router.push({ name: "register-confirm" });
      })
      .finally(() => {
        this.$root.isLoading = false;
      });
  },
  computed: {
    ...mapGetters(["getRegistrationUser", "getIdentities", "getRegistrationFirstName","getRegistrationEmail"]),
    firstName() {
      return this.getRegistrationFirstName;
    },
    email() {
      return this.getRegistrationEmail;
    }
  },
  methods: {
    formNext() {
      this.$router.push({ name: "landing" });
    }
  }
};
</script>
